<div class="content wz-form-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">world basics</span></h2>
  </div>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Form Layout -->
    <div class="form-container mx-auto">

      <!-- World Description Row -->
      <div class="form-row mb-4">
        <label for="worldDesc" class="form-label fw-bold">World description <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="worldDesc" class="form-textarea" rows="4" [(ngModel)]="description"
            placeholder="Over countless ages, continents drifted, oceans carved coasts, and life evolved in cycles—until mortals rose and gave meaning to the wild."
          [class.is-invalid]="showErrorMsg && !description.trim()"></textarea>
        </div>
      </div>

      <!-- Primary Themes/Tone -->
      <div class="form-row mb-3">
        <label for="primaryThemes" class="form-label fw-bold">Primary themes / tone <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="primaryThemes" [(ngModel)]="selectedThemes" [class.is-invalid]="showErrorMsg && !selectedThemes" [items]="themes"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <!-- World Creation Type -->
      <div class="form-row mb-3">
        <label for="creationType" class="form-label fw-bold">World creation type <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="creationType" [(ngModel)]="selectedCreationType" [class.is-invalid]="showErrorMsg && !selectedCreationType" [items]="creationTypes"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <!-- Social Hierarchy -->
      <div class="form-row mb-3">
        <label for="socialHierarchy" class="form-label fw-bold">Social hierarchy <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="socialHierarchy" [(ngModel)]="selectedHierarchy" [class.is-invalid]="showErrorMsg && !selectedHierarchy" [items]="hierarchies"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <!-- Currency Type -->
      <div class="form-row mb-3">
        <label for="currencyType" class="form-label fw-bold">Currency type <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="currencyType" [(ngModel)]="selectedCurrency" [class.is-invalid]="showErrorMsg && !selectedCurrency" [items]="currencies"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <!-- Technology Level -->
      <div class="form-row mb-3">
        <label for="techLevel" class="form-label fw-bold">Technology level <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="techLevel" [(ngModel)]="selectedTech" [class.is-invalid]="showErrorMsg && !selectedTech" [items]="techLevels"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

    </div>

    <!-- Validation Error Banner -->
    @if (showErrorMsg) {
      <div class="error-banner mb-3 mx-auto">
        <span class="error-text">{{ validationErrorText }}</span>
      </div>
    }

  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

</div>